import { createSelector } from 'reselect'
import filteredRenderImagesSelector from './filteredRenderImagesSelector'

export interface IE3DRenderImage {
    type: 'image'
    title: string
    source: string
}

const cleanImageUrl = (url: string): string => {
    return url.replace(/[?&](wid|width)=[^&]*/g, '').replace(/[?&]$/, '')
}

const e3dRenderImagesSelector = createSelector(
    [filteredRenderImagesSelector],
    (renderImages): IE3DRenderImage[] => {
        return renderImages.flatMap(renderImage => {
            const largestDetail = renderImage.renderDetails
                .sort((a, b) => b.size - a.size)[0]

            if (!largestDetail) {
                return []
            }

            return {
                type: 'image' as const,
                title: renderImage.id,
                source: cleanImageUrl(largestDetail.url),
            }
        })
    },
)

export default e3dRenderImagesSelector
